const ALLOWED_ORIGINS = ['portal.quoteplicity.com', 'preview.quoteplicity.com'];

export function detectIframe() {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export function isAllowedOrigin(origin) {
  try {
    const url = new URL(origin);
    if (url.hostname === 'localhost' || url.hostname === '127.0.0.1') return true;
    return ALLOWED_ORIGINS.some((d) => url.hostname === d || url.hostname.endsWith('.' + d));
  } catch {
    return false;
  }
}
